import { Fragment, useMemo, useReducer } from 'react';
import { useTranslate } from 'react-admin';
import Box from '@mui/material/Box';
import { dataToSendReducer } from '@/components/common/notes/show-note-forms/dataToSendReducer';
import GlobalNoteDialogFormField from '@/components/common/notes/show-note-forms/global-note-dialog-form-field';

import Typography from '@mui/material/Typography';

interface Props {
    formsData: {
        [key: string]: any;
    };
    formsOrigin: {
        data: any;
        order: number;
    }[];
    typeNote: any;
}

const ShowNoteForms = ({ formsOrigin, formsData }: Props) => {
    const translate = useTranslate();

    const dataToSendInitialState = useMemo(() => {
        let output: any = { forms: {} };

        formsOrigin?.forEach((form, index) => {
            const keyToSelect = form.data.id in formsData ? form.data.id : form.data.name;

            if (keyToSelect in formsData) {
                output.forms[index] = {
                    toSend: {
                        [keyToSelect]: formsData[keyToSelect],
                    },
                    required: false,
                    valid: true,
                };
            }
        });

        return output;
    }, [formsOrigin, formsData]);

    const [dataToSendState, dataToSendStateDispatch] = useReducer(dataToSendReducer, dataToSendInitialState);

    const stepsComponents = useMemo(() => {
        let output: {
            order: number;
            required: boolean;
            index: number;
            component: any;
            key: 'sign' | 'images' | 'forms' | 'coords';
        }[] = [];

        formsOrigin?.forEach((form, index) => {
            const required = form?.data?.required ?? false;
            const formId = form.data.id in formsData ? form.data.id : form.data.name;

            if (formId in formsData) {
                output.push({
                    order: form.order,
                    required,
                    index,
                    key: 'forms',
                    component: (
                        <GlobalNoteDialogFormField
                            required={required}
                            nodeForm={form}
                            formId={formId}
                            dataToSendState={dataToSendState}
                            dataToSendStateDispatch={dataToSendStateDispatch}
                            index={String(index)}
                            key={form.order}
                            readOnly={true}
                            // typeNote={typeNote}
                        />
                    ),
                });
            }
        });

        return output;
    }, [formsOrigin, formsData]);

    return (
        <Fragment>
            {formsData && formsOrigin && formsOrigin.length > 0 && formsData ? (
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                        justifyContent: 'start',
                    }}
                >
                    {stepsComponents.map((step) => step.component)}
                </Box>
            ) : (
                <Typography
                    sx={{
                        fontSize: 14,
                        textAlign: 'center',
                        color: (theme) => theme.palette.action.disabled,
                        py: 1,
                    }}
                >
                    {translate('errorMessages.no_details')}
                </Typography>
            )}
        </Fragment>
    );
};

export default ShowNoteForms;
